import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import CardsPage from './pages/CardsPage';
import CommandsPage from './pages/CommandsPage';
import ConfigPage from './pages/ConfigPage';
import AuctionsPage from './pages/AuctionsPage';
import AuctionDetailAdminPage from './pages/AuctionDetailAdminPage';
import AlertsPage from './pages/AlertsPage';
import OraclesPage from './pages/OraclesPage';
import OracleConfigPage from './pages/OracleConfigPage';
import OracleAssignedPage from './pages/OracleAssignedPage';
import OracleMonitorPage from './pages/OracleMonitorPage';
import CoworkPage from './pages/CoworkPage';
import SubathonPage from './pages/SubathonPage';
import TwitchCallbackRedirectPage from './pages/TwitchCallbackRedirectPage';

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { token, loading } = useAuth();
  if (loading) return <div style={{ padding: '2rem' }}>Cargando...</div>;
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

const App: React.FC = () => {
  const { token } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={token ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/auth/twitch/callback" element={<TwitchCallbackRedirectPage />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="cards" element={<CardsPage />} />
        <Route path="commands" element={<CommandsPage />} />
        <Route path="auctions" element={<AuctionsPage />} />
        <Route path="auctions/:id" element={<AuctionDetailAdminPage />} />
        <Route path="alerts" element={<AlertsPage />} />
        <Route path="oraculos" element={<OraclesPage />} />
        <Route path="oraculos/configuracion" element={<OracleConfigPage />} />
        <Route path="oraculos/asignados" element={<OracleAssignedPage />} />
        <Route path="oraculos/monitor" element={<OracleMonitorPage />} />
        <Route path="cowork" element={<CoworkPage />} />
        <Route path="extensible" element={<SubathonPage />} />
        <Route path="config" element={<ConfigPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
